export const categories = [
  {
    slug: 'park',
    name: '园区内幕',
    icon: 'ri-building-2-line',
    desc: '园区如何被包装、如何控制人员、如何与外部对接，还原真实的封闭运作方式。',
  },
  {
    slug: 'scam',
    name: '电诈套路',
    icon: 'ri-chat-off-line',
    desc: '杀猪盘、虚假投资、刷单返利等高频话术的完整流程拆解与识别要点。',
  },
  {
    slug: 'victim',
    name: '受害者经历',
    icon: 'ri-emotion-sad-line',
    desc: '经授权整理的亲历者讲述，还原被困、求助与脱身的真实过程。',
  },
  {
    slug: 'guide',
    name: '防骗指南',
    icon: 'ri-book-open-line',
    desc: '出境务工前的核查清单、家属应对流程与心理疏导建议。',
  },
];